import { ForgotPassword } from "../../../../src/components/forgot-password";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  ForgotPassword,
  Footer,
  React
};